import React from 'react';
import {IAnalytcisUserInput} from '../../../../../types/IAnalyticsUserInput';
import {IBestDataset, IPreviewData} from '../../../../../types/analytics';
import {TabKey} from '../../../../../utils/common';
import TSPlot from "../Plot/TimeSeries/TSPlot";
import { IEnrichedMetadata } from '../../../../../types/metadata';

interface TSPlotBoxProps {
  activePlotAnalytics: string | null;
  timeSeriesPreview: IPreviewData | null;
  onDatasetChange: (value: string) => void;
  previewDatasetId: string;
  isForAllAnalytics: boolean;
  setIsForAllAnalytics: (value: boolean) => void;
  globalDateRange: any[];
  setGlobalDateRange: (value: any[]) => void;
  previewDatasetTimeRange: any;
  categoryDataset: IBestDataset[];
  updatedTSData: any[];
  pointProps: string;
  pointName: string;
  userInput: IAnalytcisUserInput;
  updateUserInput: (value: Partial<IAnalytcisUserInput>) => void;
  errorUpdate: string;
  loadingButtonUpdate: boolean;
  onChangeActiveKey: (item: any, key?: TabKey) => void;
  pointOption: { label: string; value: string }[];
  onUpdateTS: (values: any) => void;
  tsPreviewError: string
  isOffline: boolean
  coordinates: number[]
  enrichedMetadata: IEnrichedMetadata[]
}

const TSPlotBox: React.FC<TSPlotBoxProps> = ({
     activePlotAnalytics,
     timeSeriesPreview,
     onDatasetChange,
     previewDatasetId,
     isForAllAnalytics,
     setIsForAllAnalytics,
     globalDateRange,
     setGlobalDateRange,
     previewDatasetTimeRange,
     categoryDataset,
     updatedTSData,
     pointProps,
     pointName,
     userInput,
     updateUserInput,
     errorUpdate,
     loadingButtonUpdate,
     onChangeActiveKey,
     pointOption,
     onUpdateTS,
     tsPreviewError,
     isOffline,
     coordinates,
     enrichedMetadata
   }) => {
  if (activePlotAnalytics !== 'Time Series') {
    return null;
  }

  return (
    <TSPlot
      onDatasetChange={onDatasetChange}
      previewDatasetId={previewDatasetId}
      isForAllAnalytics={isForAllAnalytics}
      setIsForAllAnalytics={setIsForAllAnalytics}
      globalDateRange={globalDateRange}
      setGlobalDateRange={setGlobalDateRange}
      previewDatasetTimeRange={previewDatasetTimeRange}
      datasets={categoryDataset}
      defaultValueShortName={timeSeriesPreview?.DefaultValueShortName}
      variables={timeSeriesPreview?.ItemsInfo ?? []}
      tsError={tsPreviewError}
      tsData={timeSeriesPreview?.Data?.Items ?? []}
      onUpdate={onUpdateTS}
      updatedTSData={updatedTSData}
      pointProps={pointProps}
      pointName={pointName}
      userInput={userInput}
      updateUserInput={updateUserInput}
      errorUpdate={errorUpdate}
      loadingButtonUpdate={loadingButtonUpdate}
      onChangeActiveKey={onChangeActiveKey}
      pointOption={pointOption}
      isOffline={isOffline}
      coordinates={coordinates}
      enrichedMetadata={enrichedMetadata}
    />
  );

};

export default TSPlotBox;
